import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import Breadcrumbs from "@components/shared/Breadcrumbs/Breadcrumbs";
import { useAppContextNonNull } from "@contexts/AppContext";
import FastBoundService from "@services/FastBoundService";
import { FastBoundSyncDashboard } from "../FastBoundSyncDashboard/FastBoundSyncDashboard";
import { FastBoundErrorLog } from "../FastBoundErrorLog/FastBoundErrorLog";
import IFastbound_Account from "@models/IFastbound_Account";
import IBreadcrumbs from "@models/IBreadcrumbs";

type Props = {};

export const FastBoundDashboard = (_props: Props) => {
    const { userModel, supplierModel, uiContext } = useAppContextNonNull();

    const crumbs: IBreadcrumbs[] = [
        { title: "business_integrations", url: "/business/integrations" },
        { title: "fastbound_dashboard", url: "/business/integrations/fastbound/dashboard" },
    ];

    const [accounts, setAccounts] = useState<IFastbound_Account[]>([]);
    const [dashboardRefreshKey, setDashboardRefreshKey] = useState(0);

    useEffect(() => {
        FastBoundService.getAccounts(userModel, supplierModel)
            .then(setAccounts)
            .catch((err: any) => console.error("Failed to load FastBound accounts:", err));
    }, []);

    const handleErrorDismissed = useCallback(() => {
        setDashboardRefreshKey((prev) => prev + 1);
    }, []);

    return (
        <div className={"FastBoundDashboard"}>
            <Breadcrumbs crumbs={crumbs} />
            <OwTitle title={"fastbound_dashboard"} />

            <div className={"mb-3"}>
                <Link className={"btn btn-sm btn-primary"} to={"/business/integrations/fastbound/pending_serials"}>
                    <i className={"fad fa-list me-2"} />
                    Pending Serials
                </Link>
            </div>

            <FastBoundSyncDashboard accounts={accounts} notifyFn={uiContext.notifyFn} refreshKey={dashboardRefreshKey} />
            <FastBoundErrorLog accounts={accounts} notifyFn={uiContext.notifyFn} onErrorDismissed={handleErrorDismissed} />
        </div>
    );
};
